module.exports = __webpack_public_path__ + "static/media/editgroup.d99d4449.svg";